import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable()
export abstract class MapLoader {
    abstract  load(mapKey?): Observable<boolean>
}
